<template>
    <section
        id="top_menu" ref="headerWrapper"
        class="fixed top-0 left-0 right-0 z-50 transition-transform delay-200 ease-linear"
    >
        <div
            v-if="!profile_layout" :class="page?.props?.banners?.id ? '':'hidden'"
            class="grid gap-3 mx-auto grid-cols-10 xl:grid-cols-12 bg-white border-b-2 shadow object-center overflow-hidden"
        >
            <BannerProps/>
        </div>
        <div class="flex items-center w-full h-16 bg-white border-b border-main-shade">
            <section id="top_menu_close" class="flex items-center mx-auto w-full px-3 sm:px-6 laptopXL_1:h-full">
                <button
                    :onclick="toggleSidebar"
                    class="cursor-pointer items-center justify-center mr-5 hidden laptopXL_1:flex"
                >
                    <span
                        v-html="collection.header_burger.path"
                    />
                </button>
                <a
                    class="text-main-accent cursor-pointer" href="/"
                >
                    <span v-html="collection.product_logo.path"/>
                </a>

                <!-- search -->
                <div class="relative hidden md:flex md:mx-7 ml-auto xl:ml-[100px] items-center w-auto md:w-[305px]">
                    <input
                        v-model="search_input"
                        class="rounded-xl py-1.5 px-6 w-full text-gray-800 shadow-little border border-main-shade"
                        placeholder="Поиск на ProductLand" type="text" @focus="showTags"
                    >
                    <button
                        class="w-7 h-7 absolute right-4 top-1/2 -translate-y-1/2 ease-out duration-300 transition-colors text-main-shade hover:text-main-accent pointer-events-none"
                        type="button" v-html="collection.lense.path"
                    ></button>
                </div>

                <!-- Full Screen Dropdown Overlay -->
                <transition
                    enter-active-class="transition ease-out duration-75" enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95"
                >
                    <div
                        v-show="open"
                        class="custom-scroll fixed top-[64px] left-0 right-0 max-w-[940px] h-[calc(100vh-64px)] mx-auto overflow-y-scroll z-50 p-6 rounded-md shadow-lg w-auto bg-white ring-1 ring-black ring-opacity-5"
                        style="display: none;"
                    >

                        <div class="relative">
                            <div class="md:hidden relative flex items-center w-full pr-10 mb-4">
                                <input
                                    v-model="search_input"
                                    class="rounded-xl py-1.5 px-6 w-full text-gray-800 shadow-little border border-main-shade"
                                    placeholder="Поиск на ProductLand" type="text" @focus="disableScroll()"
                                > <!-- @blur="activeScroll()" -->
                                <button
                                    class="w-7 h-7 absolute right-14 top-1/2 -translate-y-1/2 ease-out duration-300 transition-colors text-main-shade hover:text-main-accent pointer-events-none"
                                    type="button" v-html="collection.lense.path"
                                ></button>
                            </div>
                            <button
                                class="absolute top-0 md:-top-4 right-0 md:-right-4 z-10 flex items-center justify-center p-1 rounded-full"
                                @click="clearSearch" v-html="collection.cross.path"
                            ></button>
                            <div class="flex flex-wrap gap-x-4 gap-y-2">
                                <div
                                    v-for="(tag, index) in output" v-show="tag.contents_count > 0" :key="index"
                                    class="w-auto min-h-0 ease-out duration-300 transition-colors px-4 py-2.5 rounded-[15px] shadow-tag text-xs font-semibold cursor-pointer relative hover:text-white hover:bg-main-accent border bg-white border-[#D1D9E2] border-solid text-main-secondary hover:text-white hover:border-transparent hover:bg-main-accent"
                                    @click.stop="loadStream(tag)"
                                >
                                    <span v-html="search_input.length ? modifiedTag(tag) : tag.name"/> &nbsp;<span
                                    class="text-xxxs align-text-top"
                                >{{ tag.contents_count ?? null }}</span>
                                </div>
                            </div>
                        </div>

                    </div>
                </transition>

                <AddMore
                    v-if="checkAccess([1,6,7])" class="ml-4 hidden"
                />

                <div class="flex ml-auto items-center">
                    <button
                        class="flex md:hidden items-center justify-center w-7 h-7 rounded-full border border-main-shade ease-out duration-300 transition-colors text-main-shade hover:text-main-accent"
                        type="button" @click="showTags" v-html="collection.lense.path"
                    ></button>

                    <RegistrationButton v-if="!is_auth_user"
                                        class="md:block hidden"/>

                    <div v-if="!page.props.auth.user" class="ml-2">
                        <DropdownLink
                            :href="'/login'" as="a"
                        >
                            {{ $t('login.loginAdaptive') }}
                        </DropdownLink>
                    </div>
                </div>
                <DropDown/>
            </section>
        </div>

        <div
            v-show="open" class="fixed inset-0 z-40 backdrop-blur-[2px]" @click="clearSearch"
        />

    </section>
</template>
<script setup>
import {router} from '@inertiajs/vue3';
import {icons as collection} from '@/shared/assets.js';
import {aws_bucket, checkAccess, is_auth_user, page} from '@/shared/helpers.js';
import DropdownLink from '@/Components/DropdownLink.vue';
import {computed, defineAsyncComponent, inject, ref, watch} from 'vue';
import BannerProps from '@/shared/Banners/BannerProps.vue';
import {disableScroll} from '@/shared/helpers/disableScroll.js';
import {useWindowDimensions} from '@/Pages/Main/helpers/dimentions.ts';
import RegistrationButton from "@/Layouts/RegistrationButton.vue";

const headerWrapper = ref(null);
let DropDown = defineAsyncComponent(() => import('@/Layouts/Menu/DropDown.vue'));
let AddMore = defineAsyncComponent(() => import('@/Layouts/Menu/AddMore.vue'));
const courseBanner = ref(null);

const globalState = inject('globalState');
const {laptopXL_1} = useWindowDimensions();
const toggleSidebar = () => {
    globalState.openMainSideMenu = !globalState.openMainSideMenu;
};

let photo_url = computed(() => {
    if (!page.props.jetstream.managesProfilePhotos && !page?.props?.auth?.user?.profile_photo_url) return null;
    return page?.props?.auth?.user?.profile_photo_path ? aws_bucket + page.props.auth.user.profile_photo_path : null;
});

watch(globalState, () => {
    if (globalState.openMainSideMenu) {
        window.document.getElementsByTagName('body')[0].style.overflow = 'hidden';
    } else {
        window.document.getElementsByTagName('body')[0].style.overflow = '';
    }
});

defineProps(['profile_layout']);
// if (window.innerWidth < 1024) useHeaderCourseBanner(courseBanner, headerWrapper);

let open = ref(false);
let {tags} = page.props;

let output = computed(() => {
    return !page?.props?.tags?.length ? [] :
        page.props.tags.sort((a, b) => {
            if (a.contents_count === b.contents_count) {
                return 0;
            }
            return a.contents_count > b.contents_count ? -1 : 1;
        });
});

function showTags() {
    open.value = true;
    disableScroll();
}

function activeScroll() {
    open.value = false;
    const header = document?.querySelector('#top_menu');
    document.body.style.overflow = 'auto';
    document.body.style.paddingRight = '0px';
    header.style.paddingRight = '0px';
}

let focused = ref(false);
let search_input = ref('');
watch(search_input, (value) => {
    if (value.length > 0) {
        output.value = page.props.tags.filter(element => element.name.toLowerCase().indexOf(value.toLowerCase()) >= 0 || element.slug.toLowerCase().indexOf(value.toLowerCase()) >= 0);
    } else {
        output.value = page.props.tags;
    }
});

function clearSearch() {
    activeScroll();
    search_input.value = '';
    open.value = false;
}

// продумать как будет происходить подсвечивание поискового запроса если ввод на англ а вывод на русском?
function modifiedTag(tag) {
    return tag.name.toLowerCase().replace(search_input.value, `<span class="bg-yellow-100 text-main-primary">${search_input.value}</span>`);
}

function loadStream(tag) {
    router.get('/stream/' + tag.slug);
    open.value = false;
    activeScroll();
}
</script>

<style>

.custom-scroll {
    overflow-y: auto;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -ms-scroll-snap-type: y mandatory;
    scroll-snap-type: y mandatory;
}

.custom-scroll::-webkit-scrollbar-track {
    /* background-color: #D1D9E2; */
    border-radius: 10px;
    width: 4px;
    height: 8px;
}

.custom-scroll::-webkit-scrollbar {
    width: 4px;
    height: 8px;
}

.custom-scroll::-webkit-scrollbar-thumb {
    @apply bg-main-shade;
    /* background: #383247; */
    border-radius: 10px;
    width: 4px;
    height: 8px;
    /* display: none; */
}

/* .custom-scroll:hover::-webkit-scrollbar-thumb {
    display: block;
} */

</style>
